module.exports = __webpack_public_path__ + "static/media/alaskan-cruise-giveaway-enter-here-f4b1b857_thumbnail.d1a93945.jpg";